import { render, staticRenderFns } from "./groupActivities.vue?vue&type=template&id=42ccfed1&scoped=true&"
import script from "./groupActivities.vue?vue&type=script&lang=js&"
export * from "./groupActivities.vue?vue&type=script&lang=js&"
import style0 from "./groupActivities.vue?vue&type=style&index=0&id=42ccfed1&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ccfed1",
  null
  
)

export default component.exports